<template>
  <div class="autocomplete">
    <div class="input-container" style="margin-top:-23px">
    <label
      for="text"
      :class="{
        'disabledLabel': disabled,
        'focusedLabel': tieneFoco && !disabled,
        'errorLabel': hasError,
        'hiddenLabel': !labelVisible
      }"
    >{{label}}</label>
    <input
      type="text"
      :disabled="disabled" 
      :class="{ inputError: hasError }"
      v-model="search"      
      @focus="onInput"
      @keydown.down.prevent="navigate(1)"
      @keydown.up.prevent="navigate(-1)"
      @keydown.enter.prevent="select(suggestions[selectedIndex])"
      @blur="ocultar"
      ref="searchInput" 
      :placeholder="placeholder"
    />
                

    <div v-if="hasError" class="errorText">{{ errorText }}</div>
    </div>
    <!-- Sugerencias filtradas -->
    <ul v-if="showSuggestions && suggestions.length > 0" class="suggestions" @mousedown.prevent>
      <li v-for="(suggestion, index) in suggestions" :key="suggestion.cod" @click="select(suggestion)" :class="{ 'is-selected': index === selectedIndex }" >
        {{ getText(suggestion) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ControlAutoComplete',   
  props: {
    value: {
        type: Object,
        required: false,
    },
    items: {
        type: Array,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
    getText: {
      type: Function,
      required: true,
    },
    errorMessages: {
      type: [String, Array],
      required: false,
      default: '',
    },    
    abierto: {
      type: Boolean,
      required: false,
      default: false
    }    
  },

  data() {
    return {
      tieneFoco: false,
      haTenidoFoco: false,
      search: "",
      showSuggestions: false,
      suggestions: [],
      selectedIndex: -1,
    };
  },
  
  computed: {
    labelVisible() {
      return this.tieneFoco || this.value;
    },
    errorText() {
      // console.log("errorText",this.haTenidoFoco,this.tieneFoco)
      if (!this.haTenidoFoco) return '';
      if (Array.isArray(this.errorMessages)) {
        return this.errorMessages.length ? this.errorMessages[0] : '';
      }
      return this.errorMessages || '';
    },
    hasError() {
      // console.log("hasError", this.haTenidoFoco,this.tieneFoco,this.errorText)
      if (!this.haTenidoFoco) return false;
      return this.haTenidoFoco && this.errorText !== '';
    },    
    placeholder() {
      return !this.tieneFoco ? this.label : '';
    },
  },

  methods: {
    onInput() {
      this.tieneFoco = true;
      this.haTenidoFoco = true;
      this.$emit('focus')
      this.showSuggestions = true;
      this.showAllSuggestions();
      this.$refs.searchInput.select()      
    },
    navigate(direction) {
      if (this.suggestions.length > 0) {
        this.selectedIndex = (this.selectedIndex + direction + this.suggestions.length) % this.suggestions.length;
      }
      // console.log("seleccionado:"+this.selectedIndex)
    },
    select(item) {
      this.search = this.getText(item); // Mostrar el 'nombre' en el campo de entrada
      this.showSuggestions = false;
      this.$emit('input',item)
      this.$emit('change',item)
      this.$refs.searchInput.blur();
    //   console.log("disparo evento change", item)
    },
    // change() {
    //   console.log("disparo evento change")
    //   this.$emit('input',item)
    //   this.$emit('change',item)
    // },
    ocultar() {
      this.tieneFoco = false;      
      if (!this.showSuggestions) return;
    //   console.log("value",value)
      if (this.selectedIndex==-1) {
        // console.log("no hay sleeccionado")
        this.search = ""; // Vaciar el campo de búsqueda
        // console.log("disparo evento change NULL")
        this.$emit('input',null);
        this.$emit('change',null);
      }      // Usar un pequeño timeout para permitir que el clic en el elemento de la lista se registre
      setTimeout(() => {
        this.showSuggestions = false;
      }, 50);
    //   console.log("value",this.value)
    },
    showAllSuggestions() {
        // console.log("value",this.value)
       this.suggestions = this.items; // Mostrar todos los elementos al enfocar
       if (this.value) {
         this.selectedIndex = this.suggestions.findIndex(suggestion => suggestion.cod === this.value.cod); // Resaltar el elemento previamente seleccionado
         // console.log("encontradoooooooooooooo",this.selectedIndex,this.value.nombre+this.value.apellidos)
       } 
       else {
         this.selectedIndex = -1; 
       }
    },
    
  },

  
  watch: {

    value: { immediate: true, handler(newValue, oldValue) {
        //  console.log("value changed:", newValue)        
        if (newValue) {
          this.search = this.getText(newValue);
        }
        else {
          this.search = "";
        }
       }, 
    },
    search(newValue) {
      if (newValue) {
        // Filtrar solo en base al campo 'nombre' de cada objeto en la lista de items
        this.suggestions = this.items.filter((item) =>
          this.getText(item).toLowerCase().includes(newValue.toLowerCase())
        );
    //   } else {
    //     this.suggestions = [];
      }
      this.selectedIndex = -1; // Reiniciar selección
    },
    abierto(newValue) {
      if (newValue) {
        this.haTenidoFoco = false;
        this.tieneFoco = false;
      }
    },
  },

  mounted() {
    // console.log("ControlAutoComplete mounted")
    this.haTenidoFoco = false;
  }  
};
</script>

<style scoped>
.autocomplete {
  position: relative;
  width: 100%;
}
input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  margin-top:-20px;
  margin-bottom: 20px;
  border: none;
  height: 30px; 
  border-bottom: 1px solid #888;
  outline: none;
  color:#333;
  padding-left: 1px;
}
input:focus {
    border-bottom: 2px solid #3f50b4;
}
input:disabled {
  color: #999; /* Color de texto gris para indicar que no se puede editar */
  border-bottom: 0.15em dotted #888;
}
input::placeholder {
    color: #666666;
    font-size: 15px;
}
.inputError::placeholder {
  color: #ff5252;
}
.disabledLabel {
  color: #999 /* Color de texto gris para la etiqueta */
}
.focusedLabel {
  color: #3f50b4;
}
.errorLabel {
  color: #ff5252;
}
.hiddenLabel {
  visibility: hidden;
}
label {
    font-size: 11px;
}
.inputError {
  border-bottom: 1px solid #ff5252 !important; 
}
.inputError:focus {
  border-bottom: 2px solid #ff5252 !important;
}
.errorText {
  color: #ff5252;
  font-size: 12px;
  margin-top: -20px;
  margin-bottom: 5px;
}
.suggestions {
  list-style-type: none;
  margin-top:-27px;
  padding: 0;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 300px; 
  overflow-y: auto;
  position: absolute;
  width: 100%;
  background-color: white;
  z-index: 100;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}
.suggestions li {
  min-height: 40px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.15s ease;
}
.suggestions li:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.suggestions li.is-selected {
  background-color: rgba(63, 81, 181, 0.12);
  color: #3f50b4;
  font-weight: 500;
}
</style>